import React, { ReactNode, useEffect, useId, useRef, useState } from "react";
import Styles from "./AppInputDropdown.module.scss";
import Row from "../Row";
import Column from "../Column";
import Title from "../Title";
import AppDropdown from "../AppDropdown";
import { SelectProps } from "antd";

export interface AppInputDropdownProps<DataType> extends SelectProps<DataType> {
  label?: string;
  currentValue?: DataType;
  onChangeValue?: (value: DataType) => void;
  errorText?: string;
  right?: React.ReactNode;
  orientation?: "col" | "row";
  infoTooltip?: ReactNode;
  onLabelAction?: () => void;
  isRequired?: boolean;
  alwaysShowLabel?: boolean;
}

function AppInputDropdown<DataType>(props: AppInputDropdownProps<DataType>) {
  const {
    errorText,
    label,
    currentValue,
    onChangeValue,
    options = [],
    right,
    orientation = "row",
    isRequired,
    alwaysShowLabel = true,
    infoTooltip,
    onLabelAction,
    ...rest
  } = props;

  const parent = useRef<HTMLDivElement>(null);

  const elementId = useId();
  const Wrap = orientation === "row" ? Row : Column;
  return (
    <Column id={props.id || elementId} className="h-100 w-100">
      <Wrap
        className={`flex  h-100 w-100 ${orientation === "row" && "align-items-center"} gap-1`}
        ref={parent}
      >
        {alwaysShowLabel && label && <Title isRequired={isRequired} label={label} />}

        <div className={"flex-1 w-100 h-100"}>
          <AppDropdown
            currentValue={currentValue}
            onChangeValue={(e) => {
              onChangeValue?.(e);
            }}
            className={`${Styles.appInputDropdown} w-100`}
            options={options}
            {...(rest as SelectProps<DataType>)}
          />
        </div>
      </Wrap>

      {errorText && (
        <small
          className="text-error pb-1"
          style={!alwaysShowLabel || !label || orientation === "col" ? {} : { marginLeft: 120 }}
        >
          {errorText}
        </small>
      )}
    </Column>
  );
}

export default AppInputDropdown;
